<template>
  <div class="onebgBox">
    <div class="headerBox">
      <HearderPage title="乐伴伴后台数据监控中心" />
    </div>
    <div class="oneContentBox">
      <!-- 左 -->
      <div class="divLone">
        <div class="boxTitlebox">
          <div class="text">总用户</div>
        </div>
        <div class="boxContainer Bg">
          <div class="divLoneC">
            <div :class="['all']">
              总用户 <br /><span>{{ info.total_number }}</span>
            </div>
            <div class="oneI" v-for="(item, index) in info.person_list" :key="index"
              :style="divLoneCstyleList[index]">
              <span>{{ index==0?'男用户数':index==1?'女用户数':index==2?'公众号':index==3?'安卓':'IOS' }}</span>
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="divLTwo">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">品项数据</div>
        </div>
        <div class="boxContainer Bg">
          <SomePie :list="PieList" />
        </div>
      </div>
      <div class="divLTh">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">服务单数</div>
        </div>
        <div class="boxContainer Bg">
          <div class="divLThCont">
            <div class="divLThContItemOne" v-for="(item, i) in divLThContItemlist.slice(0, 2)" :key="i"
              :style="{ backgroundImage: 'url(' + divLThContItemlistBg[i] + ')' }">
              <div>{{ item.name }}</div>
              <div style="font-size: 20px;color: #FFDB7D;line-height: 23px;font-family: YouSheBiaoTiHei;">{{ item.value
                }}</div>
            </div>
            <div class="divLThContItemTwo" v-for="(item, i) in divLThContItemlist.slice(2, 5)" :key="i"
              :style="{ backgroundImage: 'url(' + divLThContItemlistBg[i + 2] + ')' }">
              <div>{{ item.name }}</div>

              <div style="font-size: 20px;color: #FFDB7D;line-height: 23px;font-family: YouSheBiaoTiHei;">{{ item.value
                }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 中 -->
      <div class="divCOneinfo">
        <div class="Titlename">总业绩</div>
        <div class="divCOneinfoItem">
          <div class="value">{{ total1 }}</div>
        </div>
        <div class="divCOnebottom">
          <div class="left">
            本月业绩 <span>{{ total2 }}</span>
          </div>
          <div class="right">
            今日业绩 <span>{{ total3 }}</span>
          </div>
        </div>

      </div>


      <div class="divCTweMap" v-show="city_list.length>0">
        <!-- <Map /> -->
        <ChinaMap :maxValue="info.city_list"/>
      </div>


      <!-- 右 -->
      <div class="divRone">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">达人数</div>
        </div>
        <div class="boxContainer Bg">
          <div class="divRoneCon">
            <div class="divRoneConItem" v-for="(item, index) in info.daren_number" :key="index">
              <div>{{ index==0?'男达人':'女达人' }}</div>
              <div class="value"> {{ item}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="divRTwo">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">达人状态</div>
        </div>
        <div class="boxContainer Bg">
          <div class="divRTwoCon">
            <div class="divRTwoConItem" v-for="(item, i) in info.daren_state_number" :key="i"
              :style="{ backgroundImage: 'url(' + divRTwoConItemListBg[i] + ')' }">
              <div class="name"> {{ i==0?'在线':i==1?'忙碌':'可预约' }}</div>
              <div class="value" :style="{ color: i == 0 ? '#b3ff2c' : i == 1 ? '#FF4646' : '#FF9B32' }"> {{ item
                }}</div>
            </div>
          </div>

        </div>
      </div>
      <div class="divRTh">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">服务单数</div>
        </div>
        <div class="boxContainer Bg">
          <div class="divRThCon">
            <div class="divRThConItem" v-for="(item, i) in info.order_list" :key="i">
              <div class="One">
                <div>
                  <img src="./assets1/18.png" alt="" align="AbsMiddle"> &nbsp;{{ item.add_time }}
                </div>
                <div :style="{ color: i == 0 ? '#15FF1C' : i == 1 ? '#FFC751' : ' #7CB5FF;' }">{{item.city_name}}
                </div>
              </div>
              <div>
                <div class="Two">{{ item.nick_name||'' }}</div>
              </div>
              <div class="Three">
                <div>金额 <span style="font-size: 18px;color: #FFF13C;font-family: YouSheBiaoTiHei;"> &nbsp; {{ item.order_amount
                    }} &nbsp;</span>元</div>
                <div>订单号 &nbsp;{{ item.order_sn }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./style.less";
import router from "@/router";
import axios from "axios";
import request from "../../utils/request";
import HearderPage from "@/components/hearderPage.vue";

import SomePie from './components/somePie.vue'
import Map from './components/map.vue'
import ChinaMap from './components/chinaMap.vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, { Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
 
// 配置Swiper使用Autoplay插件
SwiperCore.use([Autoplay]);
export default {
  name: "home",
  components: {
    HearderPage,
    SomePie,
    Map,
    ChinaMap,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      flag: 1,

      divLoneCstyleList: [
        { width: '207px', top: '2px', left: '210px' },
        { width: '160px', top: '54px', left: '257px' },
        { width: '146px', top: '100px', left: '272px' },
        { width: '165px', top: '152px', left: '253px' },
        { width: '207px', top: '200px', left: '210px' },
      ],

      divLoneCList: [
        { name: '总用户', value: 2000 },
        { name: '推广码', value: 1000 },
        { name: '公众号', value: 694 },
        { name: '自然流', value: 771 },
        { name: 'iOS', value: 122 },
        { name: 'Android', value: 517 },
      ],

      divLThContItemlist: [
        { name: '需求数量', value: 100 },
        { name: '已接单数', value: 70 },
        { name: '今日已发布需求', value: 100 },
        { name: '今日接单', value: 70 },
        { name: '服务中', value: 100 },
      ],
      divLThContItemlistBg: [
        require('./assets1/7.png'),
        require('./assets1/8.png'),
        require('./assets1/9.png'),
        require('./assets1/10.png'),
        require('./assets1/11.png'),
      ],

      divRoneConItemList: [
        { name: '男达人', value: 345 },
        { name: '女达人', value: 231 },
      ],

      divRTwoConItemList: [
        { name: '在线', value: 345 },
        { name: '忙碌', value: 231 },
        { name: '可预约', value: 584 }
      ],
      divRTwoConItemListBg: [
        require('./assets1/19.png'),
        require('./assets1/20.png'),
        require('./assets1/21.png'),
      ],

      divRThConItemList: [
        { name: 'xxxxx达人', value: 345, time: '2024-08-07 16:05', state: '已下单', number: '454874864534324' },
        { name: 'xxxxx达人', value: 231, time: '2024-08-07 16:05', state: '已下单', number: '454874864534324' },
        { name: 'xxxxx达人', value: 584, time: '2024-08-07 16:05', state: '已下单', number: '454874864534324' },
        { name: 'xxxxx达人', value: 584, time: '2024-08-07 16:05', state: '已下单', number: '454874864534324' },
        { name: 'xxxxx达人', value: 345, time: '2024-08-07 16:05', state: '已下单', number: '454874864534324' },
        { name: 'xxxxx达人', value: 231, time: '2024-08-07 16:05', state: '已下单', number: '454874864534324' },
        { name: 'xxxxx达人', value: 584, time: '2024-08-07 16:05', state: '已下单', number: '454874864534324' },
        { name: 'xxxxx达人', value: 584, time: '2024-08-07 16:05', state: '已下单', number: '454874864534324' },
      ],













      barChartsList: {
        xData: [['战保', '小铲滩', '保税', '新英湾', '高山', '海陆'], ['出操率']],
        yData: [[70, 87, 22, 19, 57, 57]],
      },

      PieList: {
        // name: '总数', value: [
        //   { name: '城市向导', value: 5, },
        //   { name: '探店打卡', value: 27, },
        //   { name: '礼仪接待', value: 2, },
        //   { name: '微醺搭子', value: 2, },
        //   { name: '桌游', value: 2, },
        //   { name: '电竞', value: 2, },
        // ],
      },

      towerBarChartsList: {
        xData: [['泡沫消防车', '水罐消防车', '专勤消防车', '高举消防车', '干粉消防车'], ['战保', '小铲滩', '保税', '新英湾', '高山', '海陆']],
        yData: [
          [70, 87, 22, 19, 57],
          [80, 87, 22, 19, 57],
          [60, 87, 22, 19, 57],
          [7, 87, 22, 19, 57],
          [40, 87, 22, 19, 57],
          [84, 87, 22, 19, 57]
        ],
      },
      totalStatsList: '986345',

      divCTweMapListPosition: [
        { top: '193px', left: '10px' },
        { top: '20px', left: '98px' },
        { top: '20px', left: '785px' },
        { top: '193px', left: '877px' },
        { top: '360px', left: '765px' },
        { top: '360px', left: '138px' },
      ],

      divCTweMapList: [
        { id: 1, name: '专勤消防车', value: 30 },
        { id: 2, name: '泡沫消防车', value: 30 },
        { id: 3, name: '水罐消防车', value: 30 },
        { id: 4, name: '高举消防车', value: 30 },
        { id: 5, name: '其他消防车', value: 30 },
        { id: 6, name: '干粉消防车', value: 30 },
      ],
      info: {},
      total1: '',
      total2: '',
      total3: '',
      city_list: []
    }
  },
  mounted() {
    axios.get('https://app.lewanban.cn/app/index.php?do=map&m=lbb').then(response => {
        this.info = response.data.data;
        console.log(123, response.data.data,this.info)
        this.total1 = this.info.money_list[0]
        this.total2 = this.info.money_list[1]
        this.total3 = this.info.money_list[2]
        this.city_list = this.info.city_list
        this.PieList = {
          name: '总数', value: [
								{ name: this.info.music_list[0].name, value: this.info.music_list[0].number, },
								{ name: this.info.music_list[1].name, value: this.info.music_list[1].number, },
								{ name: this.info.music_list[2].name, value: this.info.music_list[2].number, },
								{ name: this.info.music_list[3].name, value: this.info.music_list[3].number, },
								{ name: this.info.music_list[4].name, value: this.info.music_list[4].number, },
								{ name: this.info.music_list[5].name, value: this.info.music_list[5].number, },
          ],
        }
        this.divLThContItemlist = [
							{ name: '需求数量', value: this.info.order_number[0] },
							{ name: '已接单数', value: this.info.order_number[1] },
							{ name: '今日已发布需求', value: this.info.order_number[2] },
							{ name: '今日接单', value: this.info.order_number[3] },
							{ name: '服务中', value: this.info.order_number[4] },
        ]
        this.timer()
    }).catch(error => {
      console.error('There was an error!', error);
    })
    
  },
  methods: {
    timer() {
      setInterval(() => {
        axios.get('https://app.lewanban.cn/app/index.php?do=map&m=lbb').then(response => {
            this.info = response.data.data;
            console.log(123, response.data.data,this.info)
            this.total1 = this.info.money_list[0]
            this.total2 = this.info.money_list[1]
            this.total3 = this.info.money_list[2]
            this.city_list = this.info.city_list
            this.PieList = {
              name: '总数', value: [
                    { name: this.info.music_list[0].name, value: this.info.music_list[0].number, },
                    { name: this.info.music_list[1].name, value: this.info.music_list[1].number, },
                    { name: this.info.music_list[2].name, value: this.info.music_list[2].number, },
                    { name: this.info.music_list[3].name, value: this.info.music_list[3].number, },
                    { name: this.info.music_list[4].name, value: this.info.music_list[4].number, },
                    { name: this.info.music_list[5].name, value: this.info.music_list[5].number, },
              ],
            }
            this.divLThContItemlist = [
                  { name: '需求数量', value: this.info.order_number[0] },
                  { name: '已接单数', value: this.info.order_number[1] },
                  { name: '今日已发布需求', value: this.info.order_number[2] },
                  { name: '今日接单', value: this.info.order_number[3] },
                  { name: '服务中', value: this.info.order_number[4] },
            ]
        }).catch(error => {
          console.error('There was an error!', error);
        })
      }, 120000)
    }
  },

};
</script>

<style scoped></style>
